import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "earth",
  "use": "earth-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"earth\"><path d=\"M256 0C114.615 0 0 114.615 0 256s114.615 256 256 256 256-114.615 256-256S397.385 0 256 0zm0 480.001c-31.479 0-61.436-6.506-88.615-18.226L283.959 330.63A16.002 16.002 0 0 0 288 320v-48c0-8.837-7.163-16-16-16-56.495 0-116.102-58.731-116.687-59.313-3-3.001-7.07-4.687-11.313-4.687H80c-8.836 0-16 7.164-16 16v96a15.999 15.999 0 0 0 8.845 14.311L128 345.889v93.943C69.974 399.354 32 332.116 32 256c0-34.357 7.745-66.903 21.569-96H112c4.244 0 8.313-1.686 11.314-4.686l64-64c3-3.001 4.686-7.07 4.686-11.314V41.294C212.281 35.257 233.759 32 256 32c35.203 0 68.502 8.13 98.141 22.6a97.187 97.187 0 0 0-6.023 5.518C329.985 78.25 320 102.357 320 128s9.985 49.75 28.118 67.882c18.217 18.216 42.609 28.132 67.817 28.13 1.583 0 3.171-.04 4.759-.118 6.907 25.901 19.376 93.328-4.202 186.167a15.957 15.957 0 0 0-.421 2.612c-40.662 41.54-97.35 67.328-160.071 67.328z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/earth.svg
// module id = 6HCg
// module chunks = 1